// extracted by mini-css-extract-plugin
export var dropzone = "Dropzone_dropzone__Qsz6W";
export var dragActive = "Dropzone_dragActive__oR2T-";
export var textMain = "Dropzone_textMain__OxncK";
export var btnWrapper = "Dropzone_btnWrapper__PTP0Y";
export var rotate = "Dropzone_rotate__Wm60S";
export var dotty = "Dropzone_dotty__3yQHw";